import { Response } from '@angular/http';
import { SubscriptionService } from './../../Services/subscription.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import { IMyMarkedDate, IMyDayLabels, IMyDpOptions } from 'mydatepicker';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-subscription-create-list',
  template: require('./subscription-create-list.component.html'),
  styles: [require('./subscription-create-list.component.css')]
})
export class SubscriptionCreateListComponent implements OnInit {
  loading: boolean = false;
  AllSubscriptions: any = [];
  newSubscription: any = {};
  selectedBeginDate: any;
  selectedEndDate: any;
  newTitle: string = '';
  newDescription: string ='';
  editId:number = 0;
  openForNonMembers:boolean=false;
  singleRoomAvailable: boolean=false;
  openForNonRaceBikes: boolean=false;
  openForPersonalTransport: boolean=false;
  allowRemarks: boolean=false;
  openOnlyForMembersMeetingCriteria: boolean=false;

  extraQuestion:boolean=false;
  extraQuestionText:string='';

  normalTarif:number = 0;
  onePersonTarif:number = 0;
  discountTarif:number =0;
  prepaymentTarif:number = 0;

  noCostEvent:boolean=true;

  subscriptionYears: any=[]
  currentYear = new Date().getFullYear();


  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(  private auth: AuthService, 
                private subscriptionService: SubscriptionService) { }

  ngOnInit() {
    this.loadAllYearsOfSubscriptions();
    this.loadAllSubscriptionsForYear();
    // this.loadAllSubscriptions();
  }

  yearSelected(){
    this.loadAllSubscriptionsForYear()
  }

  loadAllSubscriptionsForYear(){
    this.openForNonMembers = false;
    this.loading = true;
    this.subscriptionService.getAllSubscriptionsByYear(this.currentYear).subscribe( res => {
      this.AllSubscriptions = res;
      this.loading = false;
    })
  }

  loadAllYearsOfSubscriptions(){
    this.subscriptionService.getAllYearsOfSubscriptions().subscribe ( res => {
      if (res.status == 200){
        this.subscriptionYears = res.value
      }
    })
  }

  switchClosed(id: number, open: boolean) {
    // console.log("id: "+id+" clicked open:"+open );

    this.subscriptionService.changeClosed(id, open).subscribe(res => {
      if (res == 200) {
        var subs = this.AllSubscriptions.find((e: any) => e.id == id)
        subs.open = open
      }
    })

  }

  SaveSubscription(){
    this.newSubscription.beginDate = String(this.selectedBeginDate.date.year)+"-"+String(this.selectedBeginDate.date.month)+"-"+String(this.selectedBeginDate.date.day)
    this.newSubscription.endDate = String(this.selectedEndDate.date.year)+"-"+String(this.selectedEndDate.date.month)+"-"+String(this.selectedEndDate.date.day)
    this.newSubscription.subject = this.newTitle;
    this.newSubscription.description = this.newDescription;
    this.newSubscription.open = false;
    this.newSubscription.openForNonMembers = this.openForNonMembers
    this.newSubscription.singleRoomAvailable = this.singleRoomAvailable

    this.newSubscription.normalTarif = this.normalTarif;
    this.newSubscription.onePersonTarif = this.onePersonTarif;
    this.newSubscription.discountTarif = this.discountTarif;
    this.newSubscription.prepaymentTarif = this.prepaymentTarif;
    this.newSubscription.noCostEvent = this.noCostEvent;
    this.newSubscription.openForNonRaceBikes = this.openForNonRaceBikes
    this.newSubscription.allowRemarks = this.allowRemarks
    this.newSubscription.openForPersonalTransport = this.openForPersonalTransport
    this.newSubscription.openOnlyForMembersMeetingCriteria = this.openOnlyForMembersMeetingCriteria

    this.newSubscription.extraQuestion = this.extraQuestion;
    this.newSubscription.extraQuestionText = this.extraQuestionText;
    

    if (this.editId > 0){
      this.newSubscription.id = this.editId;
      this.subscriptionService.updateSubscription(this.newSubscription).subscribe( res => {
        this.loadAllSubscriptionsForYear();
        
      })
      
    }else{
      this.subscriptionService.createNewSubscription(this.newSubscription).subscribe( res => {
        this.loadAllSubscriptionsForYear();
      });
    }
  }

  delete(id: number) {
    Swal.fire({
            title: 'Ben je zeker?',
            text: "Ben je zeker dat je deze activiteit wil verwijderen?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Jep',
            cancelButtonText: 'Nope'
          }).then((result) => {
            if (result.value) {
              this.subscriptionService.delete(id).subscribe(x => {
                this.loadAllSubscriptionsForYear();
              })
            }
          });
  }

  newActivityReset(){
    this.selectedBeginDate = {};
    this.selectedEndDate = {};
    this.newTitle = '';
    this.newDescription ='';
    this.editId = 0;
    this.normalTarif = 0;
    this.onePersonTarif = 0;
    this.discountTarif= 0;
    this.noCostEvent = true;
    this.singleRoomAvailable = false;
    this.allowRemarks = false;
    this.openForPersonalTransport = false;
    this.extraQuestion = false;
    this.extraQuestionText ='';
    this.openOnlyForMembersMeetingCriteria = false;
  }

  EditSubscription(subId:number){
    var s = this.AllSubscriptions.find( (s:any) => s.id == subId)
    
    var bd = new Date(s.beginDate);
    this.selectedBeginDate = {
      jsdate: bd,
      date:{year: bd.getFullYear(), month: bd.getMonth() +1, day: bd.getDate()}
    };

    var ed = new Date(s.endDate);
    this.selectedEndDate = {
      jsdate: ed,
      date:{year: ed.getFullYear(), month: ed.getMonth() +1, day: ed.getDate()}
    };  
    
    
    this.newTitle = s.subject;
    this.newDescription = s.description;
    this.editId = s.id;
    this.openForNonMembers = s.openForNonMembers;
    this.openForNonRaceBikes = s.openForNonRaceBikes;
    this.allowRemarks = s.allowRemarks;
    this.openOnlyForMembersMeetingCriteria = s.openOnlyForMembersMeetingCriteria
    this.singleRoomAvailable = s.singleRoomAvailable;
    this.openForPersonalTransport = s.openForPersonalTransport;

    this.normalTarif = s.normalTarif;
    this.onePersonTarif = s.onePersonTarif;
    this.discountTarif = s.discountTarif;
    this.prepaymentTarif = s.prepaymentTarif;
    this.noCostEvent = s.noCostEvent;

    this.extraQuestion = s.extraQuestion;
    this.extraQuestionText =s.extraQuestionText;
  }

  exportXlsx(id: number){
    this.subscriptionService.downloadExcel(id).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
    
  }

  sendEmails(id: number){
    var selectedSub = this.AllSubscriptions.find((s:any) => s.id == id);
    
    var innerHtml=`Ben je zeker dat je alle ingeschrevenen de afrekening email  wil sturen?<br><br>`

    if (selectedSub.memberCount > 1){
      innerHtml += `Er zullen ${selectedSub.memberCount} emails worden vestuurd.`
    }else{
      innerHtml += `Er zal ${selectedSub.memberCount} email worden verstuurd.`
    }
    
    
    Swal.fire({
      title: 'Ben je zeker?',
      html: innerHtml,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.subscriptionService.sendPaymentEmail(id).subscribe( (res:any)=>{
          if (res.status == 200){
            Swal.fire({
              title: 'E-mails verstuurd',
              text: "Er zijn "+res.value.emailsSend+" mail(s) verstuurd",
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Ok',
            })
          }
        })
       
      }
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/subscription-create-list/subscription-create-list.component.ts